import { ContentChildren, Directive, Input, OnChanges, QueryList, SimpleChanges } from '@angular/core';

import { ScrollButtonDirective } from './scroll-button.directive';

@Directive({
    selector: '[appScrollList]',
    standalone: true
})
export class ScrollButtonListDirective implements OnChanges {
  constructor() {}

  @Input() activeIndex: number = 0;
  @ContentChildren(ScrollButtonDirective, {descendants: true}) scrollButtons: QueryList<ScrollButtonDirective>;

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['activeIndex'] && !changes['activeIndex'].firstChange) {
      this.scrollButtons.get(this.activeIndex)?.setActive();
    }
  }

  onPrev(): void {
    if(this.activeIndex === 0) {return}
    this.activeIndex--;
    this.scrollButtons.get(this.activeIndex)?.setActive();
  }

  onNext(): void {
    if(this.activeIndex === this.scrollButtons.length - 1) {return}
    this.activeIndex++;
    this.scrollButtons.get(this.activeIndex)?.setActive();
  }
}
